/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriggerProvenanceDto
 */
export interface TriggerProvenanceDto {
    /**
     * 
     * @type {string}
     * @memberof TriggerProvenanceDto
     */
    origin?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerProvenanceDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerProvenanceDto
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerProvenanceDto
     */
    integrationInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerProvenanceDto
     */
    executionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerProvenanceDto
     */
    triggerRuleId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerProvenanceDto
     */
    mdmSyncJobId?: string;
    /**
     * 
     * @type {number}
     * @memberof TriggerProvenanceDto
     */
    triggerChainDepth?: number;
}

/**
 * Check if a given object implements the TriggerProvenanceDto interface.
 */
export function instanceOfTriggerProvenanceDto(value: object): value is TriggerProvenanceDto {
    return true;
}

export function TriggerProvenanceDtoFromJSON(json: any): TriggerProvenanceDto {
    return TriggerProvenanceDtoFromJSONTyped(json, false);
}

export function TriggerProvenanceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerProvenanceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': json['origin'] == null ? undefined : json['origin'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'integrationInstanceId': json['integrationInstanceId'] == null ? undefined : json['integrationInstanceId'],
        'executionId': json['executionId'] == null ? undefined : json['executionId'],
        'triggerRuleId': json['triggerRuleId'] == null ? undefined : json['triggerRuleId'],
        'mdmSyncJobId': json['mdmSyncJobId'] == null ? undefined : json['mdmSyncJobId'],
        'triggerChainDepth': json['triggerChainDepth'] == null ? undefined : json['triggerChainDepth'],
    };
}

export function TriggerProvenanceDtoToJSON(json: any): TriggerProvenanceDto {
    return TriggerProvenanceDtoToJSONTyped(json, false);
}

export function TriggerProvenanceDtoToJSONTyped(value?: TriggerProvenanceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'origin': value['origin'],
        'userId': value['userId'],
        'sessionId': value['sessionId'],
        'integrationInstanceId': value['integrationInstanceId'],
        'executionId': value['executionId'],
        'triggerRuleId': value['triggerRuleId'],
        'mdmSyncJobId': value['mdmSyncJobId'],
        'triggerChainDepth': value['triggerChainDepth'],
    };
}

